import React from "react";
import { useTranslation } from "react-i18next";
import DynamicProductComparison from "./ProductComparison";
import { smartBandsData } from "./deta-ProductComparison/smartBandsData";
import { smartBandTranslations } from "./deta-ProductComparison/smartBandTranslations";

const SmartBandComparison: React.FC = () => {
    const { i18n } = useTranslation();
    const lang = (i18n.language || "fa").split("-")[0];
    const langKey = (["fa", "en", "ar", "tr"].includes(lang) ? lang : "fa") as keyof typeof smartBandTranslations;
    const t = smartBandTranslations[langKey] || smartBandTranslations.fa;

    return (
        <DynamicProductComparison
            title={t.title}
            subtitle={t.subtitle}
            description={t.description}
            data={smartBandsData}
            defaultCategory="all"
            showCategories={true}
        />
    );
};

export default SmartBandComparison;